export default __webpack_public_path__ + "static/media/Gloves of the Crawling Chaos.f057c45c.jpg";